<template>
    <div v-loading="loading" :element-loading-text="loadingText">
        <div class="header-div" v-if="false">
            <div style="font-size:20px" @click="menuBtnClick">
                <i class="el-icon-more"></i>
            </div>
            <!-- <div>
                {{ nowTime }}
            </div> -->
            <div>
                <diV class="status-div">
                    <div class="delay-status"
                        :class="{ 'success': networkDelay < 250, 'warning': networkDelay >= 250 && networkDelay < 500, 'error': networkDelay >= 500 }"
                        style="margin-right: 5px;"></div>
                    {{ networkDelay + 'ms' }}
                </diV>
                <div>
                    {{ serverTime }}
                </div>
            </div>
        </div>
        <div>
            <router-view></router-view>
        </div>

        <el-drawer title="菜单" :visible.sync="menuVis" :with-header="false" direction="ltr" :size="250" :router="true">
            <div>
                <div class="menu-div">
                    <div class="menu-icon-div" @click="logoutClick">
                        <i class="el-icon-s-release" style="color: #999999;"></i>
                        <p>退出登录</p>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import Common from '../../utils/utils-common';
import AppServices from "../../request-server/request-services/app-services";


export default {
    data() {
        return {
            nowTime: new Date(),
            networkDelay: 9999,
            menuVis: false,
            activeRoute: "",
            serverTime: "",
            loading: false,
            loadingText: "页面加载中..."
        };
    },
    methods: {
        menuBtnClick() {
            this.menuVis = true;
        },
        logoutClick() {
            this.$confirm('确定要注销登录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$store.commit("loginout");
                this.$router.replace('/referee/login');
            });
        }
    },
    created() {
        let h = setInterval(() => {
            let date = new Date();
            this.nowTime = Common.formatDate(date, "YYYY/MM/DD HH:mm:ss");
            let delay1 = new Date() * 1;
            let reqParams = {};
            if (this.$store.state.referee) {
                if (this.$store.state.referee.k1) reqParams.k1 = this.$store.state.referee.k1;
                if (this.$store.state.referee.k2) reqParams.k2 = this.$store.state.referee.k2;
            }
            AppServices.heart(reqParams).then(res => {
                let delay2 = new Date() * 1;
                this.networkDelay = delay2 - delay1;
                this.serverTime = res.data.st;
                if (!res.data.success) {
                    this.$alert("裁判信息不存在,请重新录入", "", {
                        type: 'error'
                    }).then(() => {
                        this.$store.commit("cleanRefereeInfo");
                        this.$store.commit("cleanRefereeCacheKey");
                        location.reload();
                    });
                } else {
                    this.$store.commit("setRefereeUid", res.data.uid);
                    // if (res.data.uid) {
                    //     this.$store.commit("setRefereeUid", res.data.uid);
                    // }
                    if (res.data.userupdate) {
                        this.$store.commit("setRefereeUpdateUserTime", res.data.userupdate);
                    }
                }
            }).catch(err => {
                this.networkDelay = 9999;
                this.loadingText = "与服务器断开连接,10s后将跳转回登录页";
                this.loading = true;
                setTimeout(() => {
                    this.$store.commit("loginout");
                    this.$router.replace('/referee/login');
                }, 10000);
            });
        }, 3000);
        this.$store.commit("saveHeartInterval", h);
        this.activeRoute = this.$route.path;
    },
    beforeDestroy() {
        this.$store.commit("cleanHeartInterval");
    }
}
</script>

<style lang="scss" scoped>
.delay-status {
    border-radius: 50%;
    width: 8px;
    height: 8px;
}

.status-div {
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
}

.success {
    background-color: #65fd19;
    box-shadow: 0 0 13px 2px #65fd19;
}

.error {
    background-color: #F56C6C;
    box-shadow: 0 0 13px 2px #F56C6C;
}

.warning {
    background-color: #E6A23C;
    box-shadow: 0 0 13px 2px #E6A23C;
}

.header-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px;
    background-color: rgb(102, 177, 255);
    color: white;
    max-height: 5vh;
}

.menu-div {
    display: flex;
    flex-flow: row;
}

.menu-icon-div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    width: 33%;
    margin-top: 2%;
    margin-bottom: 1%;

    >p {
        color: #333333;
        font-size: 13px;
    }

    >i {
        font-size: 35px;
    }
}
</style>
